
import { useState } from "react";
import { VerificationLayout } from "@/components/seller/verification/VerificationLayout";
import { VerificationSteps } from "@/components/seller/verification/VerificationSteps";
import { VerificationLoading } from "@/components/seller/verification/VerificationLoading";
import { useVerificationData } from "@/components/seller/verification/useVerificationData";

const CookVerification = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const { data: verification, isLoading } = useVerificationData();

  if (isLoading) {
    return <VerificationLoading />;
  }

  return (
    <VerificationLayout currentStep={2} totalSteps={3}>
      <div className="space-y-6">
        <div>
          <h2 className="text-2xl font-semibold tracking-tight text-primary">
            Document Verification
          </h2>
          <p className="text-foreground">
            Please provide the required documentation to verify your identity and kitchen safety standards.
          </p>
        </div>

        <VerificationSteps
          currentStep={currentStep}
          onStepComplete={(step) => setCurrentStep(step + 1)}
          verification={verification}
        />
      </div>
    </VerificationLayout>
  );
};

export default CookVerification;
